module.exports = __webpack_public_path__ + "images/817290dd1f3def12a72bfa544092093e.svg";